module.exports = __webpack_public_path__ + "static/media/watch.b4e58e91.jpg";